// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__LPH7r","selected":"Chip_selected__1jqQ2"};